module.exports = __webpack_public_path__ + "img/Strata.5764f984.png";